import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import './AuthForm.css';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await axios.post(
        `${process.env.REACT_APP_API}/api/auth/forgot-password`,
        { email }
      );
      
      setSuccess(true);
      setEmail('');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to send reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="auth-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="auth-form"
          style={{ textAlign: 'center' }}
        >
          <div style={{
            width: '80px',
            height: '80px',
            margin: '0 auto 24px',
            background: 'linear-gradient(135deg, #15803d 0%, #166534 100%)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '40px'
          }}>
            ✉️
          </div>
          <h2 style={{ marginBottom: '16px' }}>Check Your Email</h2>
          <p style={{ color: '#64748b', marginBottom: '24px', lineHeight: 1.6 }}>
            If an account exists with this email, we've sent password reset instructions.
            Please check your inbox and spam folder.
          </p>
          <Link to="/login" className="auth-link-button" style={{
            display: 'inline-block',
            padding: '12px 24px',
            background: 'linear-gradient(135deg, #15803d 0%, #166534 100%)',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '999px',
            fontWeight: 600
          }}>
            Back to Login
          </Link>
        </motion.div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <form className="auth-form" onSubmit={handleSubmit}>
        <h2>Forgot Password?</h2>
        <p style={{ color: '#64748b', marginBottom: '24px', fontSize: '14px' }}>
          Enter your email address and we'll send you instructions to reset your password.
        </p>

        {error && (
          <div style={{
            padding: '12px',
            background: '#fef2f2',
            border: '1px solid #fecaca',
            borderRadius: '8px',
            color: '#dc2626',
            fontSize: '14px',
            marginBottom: '16px'
          }}>
            {error}
          </div>
        )}

        <div className="form-group">
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <button type="submit" disabled={loading}>
          {loading ? 'Sending...' : 'Send Reset Link'}
        </button>

        <div className="auth-links" style={{ marginTop: '16px' }}>
          <Link to="/login">Back to Login</Link>
          {' · '}
          <Link to="/register">Create Account</Link>
        </div>
      </form>
    </div>
  );
}

export default ForgotPassword;
